const CATEGORISATION_PARAMS = {
  SHORT_PERIOD: [
    {
      uptoFraction: 0.10,
      commentaryElement: <span><i>Nothing of note</i></span>,
    },
    {
      uptoFraction: 0.15,
      commentaryElement: <span><i>Some rainfall, but not significant</i></span>,
    },
    {
      uptoFraction: 0.22,
      commentaryElement: <span><i>Around a weeks worth of rainfall</i></span>,
    },
    {
      uptoFraction: 0.38,
      commentaryElement: <span><i><b>Notable</b>: Around 1-2 weeks of rainfall</i></span>,
    },
    {
      uptoFraction: 0.45,
      commentaryElement: <span><i><b>Notable</b>: Around 2 weeks of rainfall</i></span>,
    },
    {
      uptoFraction: 0.65,
      commentaryElement: <span><i><b>Notable</b>: Around half a months rainfall</i></span>,
    },
    {
      uptoFraction: 0.85,
      commentaryElement: <span><i><b>Significant</b>: Over half a months rainfall</i></span>,
    },
    {
      uptoFraction: 1.00,
      commentaryElement: <span><i><b>Significant</b>: Almost a months worth of rain in a short period</i></span>,
    },
    {
      uptoFraction: Infinity,
      commentaryElement: <span><i><b>Extreme rainfall event</b>: Over a months rain</i></span>,
    },
  ],
};

const RenderRainfallCommentary = function ({
  periodTotal,
  meanByMonth,
  CATEGORISATION_PARAM = "SHORT_PERIOD",
}) {
  const meanOfMeans = meanByMonth.length
    ? meanByMonth.reduce((acca, m) => acca + parseFloat(m), 0) / meanByMonth.length
    : 0;

  const periodTotalFl = parseFloat(periodTotal);
  const fracOfMean = periodTotalFl / meanOfMeans;

  if (
    isNaN(periodTotalFl) ||
    isNaN(meanOfMeans) ||
    !meanOfMeans ||
    !isFinite(fracOfMean) ||
    fracOfMean < 0
  ) {
    return (
      <span>
        <i>None</i>
      </span>
    );
  }

  // Select the correct scheme (fallback to SHORT_PERIOD if not found)
  const scheme =
    CATEGORISATION_PARAMS[CATEGORISATION_PARAM] || CATEGORISATION_PARAMS.SHORT_PERIOD;

  // Ensure ascending order just in case
  const sorted = [...scheme].sort((a, b) => a.uptoFraction - b.uptoFraction);

  // Pick the first bucket where fracOfMean <= uptoFraction
  const bucket =
    sorted.find((b) => fracOfMean <= b.uptoFraction) || sorted[sorted.length - 1];

  return bucket.commentaryElement || (
    <span>
      <i>None</i>
    </span>
  );
};

export default RenderRainfallCommentary;
